import { WidgetContainer } from '@pulse-web-ui/containers';
import { styled } from '@pulse-web-ui/theme';

import { PageBackButton } from '@shared/ui/buttons';

export const Container = styled(WidgetContainer)`
  ${PageBackButton} {
    margin-bottom: 0;
  }
`;
